const updates = [
  {
    time: '16:42',
    title: '突发：某省会城市发生重大公共安全事件，多部门联合响应',
    tag: '突发事件',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    time: '15:18',
    title: '独家获取：某部委内部工作会议纪要流出，多项政策信号释放',
    tag: '政策解读',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    time: '14:05',
    title: '圈内人士透露：某知名投资机构正秘密布局新能源赛道',
    tag: '资本动向',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    time: '12:30',
    title: '最新消息：某跨境电商平台涉嫌走私被海关立案调查',
    tag: '行业监管',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    time: '10:55',
    title: '多位员工匿名爆料：某互联网大厂强制加班问题严重',
    tag: '劳动权益',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    time: '09:20',
    title: '独家揭秘：某知名餐饮连锁品牌后厨卫生状况堪忧',
    tag: '消费安全',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    time: '07:45',
    title: '内部人士发声：某上市公司财报存在重大数据造假嫌疑',
    tag: '财务造假',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    time: '06:10',
    title: '独家：某大型体育赛事筹备工作严重滞后，面临延期风险',
    tag: '赛事动态',
    tagColor: 'bg-accent-100 text-accent-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-10 md:mb-14">
          <div>
            <span className="text-xs font-label font-semibold text-primary-500 uppercase tracking-wider">
              最新快讯
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-2">
              爆料快讯
            </h2>
            <p className="text-foreground-500 text-sm mt-2">
              实时追踪最新爆料动态，不遗漏任何重要资讯
            </p>
          </div>
          <div className="flex items-center gap-2 mt-4 sm:mt-0">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
            <span className="text-xs text-primary-500 font-medium">实时更新中</span>
          </div>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/60 hidden sm:block"></div>

          <div className="space-y-0">
            {updates.map((item, i) => (
              <a
                key={i}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group flex gap-5 py-4 transition-colors cursor-pointer"
              >
                <div className="hidden sm:flex flex-col items-center shrink-0 pt-1">
                  <span className="text-xs font-label font-medium text-foreground-400 whitespace-nowrap">
                    {item.time}
                  </span>
                  <div className="w-2.5 h-2.5 rounded-full bg-background-50 border-2 border-background-300 mt-2 group-hover:border-primary-400 transition-colors"></div>
                </div>

                <div className="flex-1 min-w-0 pb-4 border-b border-background-200/60">
                  <div className="flex items-center gap-2 mb-1.5 sm:hidden">
                    <span className="text-xs font-label font-medium text-foreground-400">{item.time}</span>
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className={`hidden sm:inline-block shrink-0 px-2 py-0.5 rounded text-[10px] font-medium ${item.tagColor} mt-0.5`}>
                      {item.tag}
                    </span>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </h3>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}